import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-social-registry-list',
  templateUrl: './social-registry-list.component.html',
  styleUrls: ['./social-registry-list.component.css'],
})
export class SocialRegistryListComponent {
  url: string = 'socialRegistries';
  data: Array<any> = [];
  searchText = '';
  filteredData: Array<any> = [];
  searchSuggestions: string[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 50;

  modalTitle: string = '';
  modalContent: string | null = null;

  filters = {
    status: '',
    platform: 'instagram',
    vertical: '',
    asset_type: '',
    scheduled: '',
  };

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    let queryParams = `?page=${this.currentPage}&limit=${this.itemsPerPage}&search=${this.searchText}`;

    if (this.filters.status) queryParams += `&status=${this.filters.status}`;
    if (this.filters.platform)
      queryParams += `&platform=${this.filters.platform}`;
    if (this.filters.vertical)
      queryParams += `&vertical=${this.filters.vertical}`;
    if (this.filters.asset_type)
      queryParams += `&asset_type=${this.filters.asset_type}`;
    if (this.filters.scheduled === 'false') queryParams += `&scheduled_at=null`;

    this.dataService
      .getData(`${this.url}${queryParams}`)
      .subscribe((response) => {
        if (response && response.data) {
          console.log('response.data', response.data);
          this.data = response.data;
          this.filteredData = [...this.data];
          this.updateSuggestions();
        }
      });
  }

  applyFilters(): void {
    this.currentPage = 1;
    this.getData();
  }

  resetFilters(): void {
    this.filters = {
      status: '',
      platform: '',
      vertical: '',
      asset_type: '',
      scheduled: '',
    };
    this.applyFilters();
  }

  updateItemStatus(id: string, status: string): void {
    this.dataService
      .putData(`${this.url}/${id}/status`, { status })
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  deleteData(id: string): void {
    if (!confirm('¿Desea eliminar el registro?')) {
      return;
    }

    this.dataService
      .deleteData(`${this.url}/delete/${id}`)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  approveItem(id: string): void {
    this.dataService
      .putData(`${this.url}/${id}/approve`, {})
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  isItemComplete(item: any): boolean {
    return !!(
      item.social_asset_id &&
      item.title_internal &&
      item.platform &&
      item.vertical &&
      item.channel_target &&
      item.asset_type &&
      item.geo_scope_type &&
      item.caption &&
      item.creative_url &&
      item.published_url &&
      item.publish_tool
    );
  }

  updateSuggestions() {
    const sugerenciasSet = new Set<string>();
    this.data.forEach((item) => {
      if (item.social_asset_id) sugerenciasSet.add(item.social_asset_id);
      if (item.title_internal) sugerenciasSet.add(item.title_internal);
    });
    this.searchSuggestions = Array.from(sugerenciasSet).filter(Boolean);
  }

  showModal(title: string, content: string) {
    this.modalTitle = title;
    this.modalContent = content;
  }

  closeModal() {
    this.modalContent = null;
  }
}
